module.exports = __webpack_public_path__ + "static/media/icon_touch_id.2e8b2f51.png";